/**
 * Sorts an array of objects by a specified column and direction.
 * @param {*} array
 * @param {*} column
 * @param {*} direction // 'ASC' or 'DESC'
 * @param {*} sortConfig
 * @returns
 */
export const sortArrayByColumn = (array, column, direction, sortConfig) => {
  const columnConfig = sortConfig.find(config => config.key === column);
  if (!columnConfig) return array;
  if (columnConfig?.sort) {
    return columnConfig.sort(array, column, direction);
  }
  return [...array].sort((a, b) => {
    const aValue = a[column];
    const bValue = b[column];

    if (columnConfig.dataType === 'date') {
      return direction === 'ASC'
        ? new Date(aValue) - new Date(bValue)
        : new Date(bValue) - new Date(aValue);
    }

    if (columnConfig.dataType === 'number') {
      return direction === 'ASC'
        ? parseFloat(aValue) - parseFloat(bValue)
        : parseFloat(bValue) - parseFloat(aValue);
    }

    return direction === 'ASC'
      ? aValue.localeCompare(bValue)
      : bValue.localeCompare(aValue);
  });
};

/**
 * @param {Object[]} data
 * @param {{ key: string, values: any[] }[]} filters
 * @returns {Object[]}
 */
export function filterData(data, filters) {
  if (!Array.isArray(filters) || filters.length === 0) {
    return data;
  }

  // Only keep filters that actually have values
  const activeFilters = filters.filter(
    f => Array.isArray(f.values) && f.values.length > 0,
  );

  return data.filter(item =>
    activeFilters.every(({ key, values }) => {
      const raw = item[key];
      const itemStr = String(raw ?? '').trim();

      return values.some(val => {
        const valStr = String(val ?? '').trim();
        return itemStr === valStr;
      });
    }),
  );
}

/**
 * Returns unique values from a specified column in an array of objects.
 * @param {*} array
 * @param {*} column
 * @returns
 */
export function getUniqueColumnValues(array, column) {
  const unique = new Set();
  array.forEach(item => {
    const raw = item[column];
    if (raw != null) {
      unique.add(String(raw));
    }
  });
  return [...unique];
}

/**
 * Sorts an array of objects by a date column in ascending or descending order.
 * @param {*} array
 * @param {*} column
 * @param {*} direction
 * @returns
 */
export function sortByDate(array, column, direction) {
  return [...array].sort((a, b) => {
    const dateA = new Date(a[column]);
    const dateB = new Date(b[column]);
    if (direction === 'ASC') {
      return dateA - dateB;
    }
    return dateB - dateA;
  });
}
